export default "__VITE_PUBLIC_ASSET__6107b558__"